"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _server = require("b2b-components/utils/server");
var _Tooltip = require("../Tooltip");
const Content = _ref => {
  let {
    children,
    className,
    isTooltipVisible,
    onCopy,
    onMouseLeave,
    onMouseEnter,
    tooltipAnchorRef,
    tooltipPosition,
    tooltipRef,
    tooltipText
  } = _ref;
  const body = !_server.isServer ? document.body : undefined;
  const Portal = () => /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    position: tooltipPosition,
    tooltipRef: tooltipRef
  }, tooltipText), body);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    onClick: onCopy,
    onMouseLeave: onMouseLeave,
    onMouseEnter: onMouseEnter,
    ref: tooltipAnchorRef
  }, children), isTooltipVisible && /*#__PURE__*/_react.default.createElement(Portal, null));
};
exports.Content = Content;
//# sourceMappingURL=Content.js.map